import { h } from 'preact'
import { useCallback, useEffect } from 'preact/hooks'
import { useAppState } from 'lib/appState'

export function useAdminOrganizations(componentName) {
  const {
    takeAction,
    adminOrganizations,
    loadingAdminOrganizations,
    errorLoadingAdminOrganizations,
  } = useAppState({
    adminOrganizations: 'adminOrganizations',
    loadingAdminOrganizations: 'loadingAdminOrganizations',
    errorLoadingAdminOrganizations: 'errorLoadingAdminOrganizations',
  }, componentName)

  useEffect(() => {
    if (adminOrganizations || loadingAdminOrganizations) return
    takeAction('network.loadAdminOrganizations')
  }, [adminOrganizations, loadingAdminOrganizations])

  return {
    adminOrganizations,
    loadingAdminOrganizations,
    errorLoadingAdminOrganizations,
  }
}

export function useOrganizationHierarchy(organizationApikey, componentName) {
  const {
    takeAction,
    hierarchy,
    loadingHierarchy,
    errorLoadingHierarchy,
  } = useAppState({
    [`organizationHierarchy:${organizationApikey}`]: 'hierarchy',
    [`organizationHierarchy:${organizationApikey}:loading`]: 'loadingHierarchy',
    [`organizationHierarchy:${organizationApikey}:error`]: 'errorLoadingHierarchy',
  }, componentName)

  useEffect(() => {
    if (hierarchy || loadingHierarchy || !organizationApikey) return
    takeAction('network.loadOrganizationHierarchy', organizationApikey)
  }, [hierarchy, loadingHierarchy, organizationApikey])

  return {
    hierarchy,
    loadingHierarchy,
    errorLoadingHierarchy,
  }
}

export function useOrganizationAdmins(organizationApikey, componentName) {
  const {
    takeAction,
    admins,
    loadingAdmins,
    errorLoadingAdmins,
  } = useAppState({
    [`organizationAdmins:${organizationApikey}`]: 'admins',
    [`organizationAdmins:${organizationApikey}:loading`]: 'loadingAdmins',
    [`organizationAdmins:${organizationApikey}:error`]: 'errorLoadingAdmins',
  }, componentName)

  useEffect(() => {
    if (admins || loadingAdmins || !organizationApikey) return
    takeAction('network.getOrganizationAdmins', organizationApikey)
  }, [admins, loadingAdmins, organizationApikey])

  return {
    admins,
    loadingAdmins,
    errorLoadingAdmins,
  }
}

export function useConvertNetworkType(componentName) {
  const { takeAction } = useAppState({}, componentName)

  const convertNetworkType = useCallback(({
    organizationApikey,
    targetNetworkType,
    isMasterOrg,
    parentOrganizationApikey,
    onSuccess,
    onError
  }) => {
    return takeAction('network.convertNetworkType', {
      organizationApikey,
      targetNetworkType,
      isMasterOrg,
      parentOrganizationApikey,
      onSuccess,
      onError
    })
  }, [takeAction])

  return {
    convertNetworkType,
  }
}
